module.exports = __webpack_public_path__ + "assets/Beruhigungsmittel_Schlafmittel.4d955adb.png";